<template>
    <div class="columns is-marginless px-4 py-4">
        <div class="column is-6-tablet">
            <div class="field">
                <p v-t="'projectConfiguration.project_title'" class="label" />
                <p class="control">
                    <input
                        v-model="project.title"
                        :class="{ 'is-static': !canEdit }"
                        :readonly="!canEdit"
                        :placeholder="$t('project_title_input_placeholder')"
                        class="input"
                        type="text"
                    />
                </p>
            </div>
            <div class="field">
                <p
                    v-t="'projectConfiguration.project_description'"
                    class="label"
                />
                <p class="control">
                    <textarea
                        v-model="project.description"
                        :class="{ 'is-static': !canEdit }"
                        :readonly="!canEdit"
                        :placeholder="
                            $t('project_description_input_placeholder')
                        "
                        class="textarea"
                    />
                </p>
            </div>
        </div>
        <div class="column is-6-tablet">
            <!--<div class="field">
        <p 
          v-t="'projectConfiguration.reference_url'" 
          class="label is-size-7" />
        <p class="control">
          <input
            v-model="project.url"
            :class="{ 'is-static': !canEdit }"
            :readonly="!canEdit"
            :placeholder="$t('project_url_input_placeholder')"
            class="input"
            type="url"
          />
        </p>
      </div>-->
            <div v-if="isAdmin" class="field">
                <p v-t="'projectConfiguration.suggested_tags'" class="label" />
                <p class="control">
                    <InputTags
                        v-model="project.suggestedTags"
                        :class="{ 'is-static': !canEdit }"
                        :readonly="!canEdit"
                    />
                </p>
                <p class="is-size-7 is-italic has-text-grey">
                    {{ $t('projectConfiguration.suggested_tags_description') }}
                </p>
            </div>

            <!--<div v-if="$store.getters.isAdmin">
                <div class="field">
                    <p v-t="'project.settings.save_in'" class="label" />
                    <div class="control is-expanded">
                        <div
                            :class="{ 'is-active': showDropdown }"
                            class="dropdown is-fullwidth"
                        >
                            <div
                                class="dropdown-trigger"
                                @click="showDropdown = !showDropdown"
                            >
                                <button
                                    class="button"
                                    aria-haspopup="true"
                                    aria-controls="dropdown-menu"
                                >
                                    <span
                                        v-if="hasFolder"
                                        class="has-text-left"
                                        >{{ project.folder.name }}</span
                                    >
                                    <span v-else class="has-text-left"
                                        >Mis proyectos</span
                                    >
                                    <span
                                        class="icon is-small is-flex-shrink-5"
                                    >
                                        <i
                                            class="fas fa-angle-down"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </button>
                            </div>
                            <div
                                id="dropdown-menu"
                                class="dropdown-menu"
                                role="menu"
                            >
                                <div class="dropdown-content">
                                    <a
                                        class="dropdown-item"
                                        @click="selectFolder({})"
                                        >Mis proyectos</a
                                    >
                                    <hr class="dropdown-divider" />
                                    <a
                                        v-for="folder in folders"
                                        :key="folder._id"
                                        :class="{
                                            'is-active':
                                                selectedFolder._id ==
                                                folder._id,
                                        }"
                                        class="dropdown-item"
                                        @click="selectFolder(folder)"
                                        >{{ folder.name }}</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>
import InputTags from '@/components/InputTags';
import { fetchItems } from '@/services/API';
import _ from 'underscore';
export default {
    components: {
        InputTags,
    },
    model: {
        prop: 'project',
    },
    props: {
        project: {
            type: Object,
            default: () => {
                return {};
            },
        },
        canEdit: { type: Boolean, default: false },
        isAdmin: { type: Boolean, default: false },
    },
    data() {
        return {
            folders: [],
            selectedFolder: this.project.folder || {},
            showDropdown: false,
        };
    },
    computed: {
        hasFolder() {
            return !_.isEmpty(this.project.folder);
        },
    },
    mounted() {
        this.fetchFolders();
    },
    methods: {
        async fetchFolders() {
            const folders = await fetchItems('folder');
            this.folders = folders.data;
        },
        selectFolder(folder) {
            this.selectedFolder = folder;
            this.showDropdown = false;
            this.project.folder = folder;
        },
    },
};
</script>

<style scoped>
.lb-select-folder .control .button {
    height: 2.5rem;
}
.label {
    font-weight: normal;
}
.dropdown.is-fullwidth {
    display: flex;
}

.dropdown.is-fullwidth * {
    width: 100%;
}
</style>
